import e from "react";
import { formatPrice as d } from "./index110.mjs";
import t from "./index275.mjs";
const o = ({
  name: a,
  totalPrice: r,
  currency: m,
  index: i
}) => /* @__PURE__ */ e.createElement("div", { "data-testid": `extra-item-label-${i}` }, /* @__PURE__ */ e.createElement("div", { className: t.name, "data-testid": "extra-name" }, a), /* @__PURE__ */ e.createElement("div", { className: t.price, "data-testid": "extra-price" }, d(Number(r), m)));
export {
  o as ExtraHeader
};
